<script>
import Layout from '@layouts/main.vue'

export default {
  page() {
    return {
      title: this.user.name,
      meta: [
        {
          name: 'description',
          content: `The user profile for ${this.user.name}.`,
        },
      ],
    }
  },
  components: { Layout },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <Layout>
    <div class="container">
      <div class="row justify-content-center mt-5">
        <div class="col-lg-3 mb-3">
          <ul class="nav nav-tabs flex-lg-column" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                data-toggle="tab"
                href="#profile"
                role="tab"
                aria-controls="profile"
                aria-selected="true"
                >Your Profile</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#profile" role="tab"
                >Carrier Access</a
              >
            </li>
          </ul>
        </div>
        <div class="col-xl-8 col-lg-9">
          <div class="card">
            <div class="card-body">
              <div class="tab-content">
                <div
                  id="profile"
                  class="tab-pane fade active show"
                  role="tabpanel"
                >
                  <!--end of avatar-->
                  <form>
                    <div class="form-group row align-items-center">
                      <label class="col-3">Username</label>
                      <div class="col">
                        <input
                          type="text"
                          placeholder="First name"
                          :value="user.UserName"
                          class="form-control"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label class="col-3">Fullname</label>
                      <div class="col">
                        <input
                          type="text"
                          placeholder="First name"
                          :value="user.FullName"
                          class="form-control"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label class="col-3">Carrier</label>
                      <div class="col">
                        <input
                          type="text"
                          :value="user.Carrier"
                          class="form-control"
                          required
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label class="col-3">Carrier Filters</label>
                      <div class="col">
                        <div>
                          <b-form-tags
                            :disabled="true"
                            :value="user.CarrierChoice.split(',')"
                            class="mb-2"
                          ></b-form-tags>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label class="col-3">Database</label>
                      <div class="col">
                        <input
                          type="text"
                          :value="user.Database"
                          class="form-control"
                          required
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label class="col-3">Site</label>
                      <div class="col">
                        <input
                          type="text"
                          :value="user.Site"
                          class="form-control"
                          required
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label class="col-3">Company</label>
                      <div class="col">
                        <input
                          type="text"
                          :value="user.Company"
                          class="form-control"
                          required
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label class="col-3">TimeZone</label>
                      <div class="col">
                        <input
                          type="text"
                          :value="user.TimeZone"
                          class="form-control"
                          required
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label class="col-3">Roles</label>
                      <div class="col">
                        <div>
                          <b-form-tags
                            :disabled="true"
                            :value="user.Roles"
                            class="mb-2"
                          ></b-form-tags>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-end">
                      <button
                        type="submit"
                        class="btn btn-primary"
                        disabled="true"
                        >Save</button
                      >
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
